export default function matchField (field, entity, type) {
  const hasCustomSuffix = field.endsWith('_custom');
  const isCustom = hasCustomSuffix || type === 'custom';

  const normalizedField = hasCustomSuffix
    ? field.slice(0, -7)
    : field;

  let label;

  switch (true) {
    case normalizedField === 'host__os':
      label = 'Asset Os';
      break;

    case normalizedField === 'easeofresolution':
      label = 'Ease of Resolution';
      break;

    case normalizedField === 'status_code':
      label = 'Status Code';
      break;

    case normalizedField === 'pname':
      label = 'Param Name';
      break;

    case normalizedField === 'policyviolations':
      label = 'Policy Violations';
      break;

    case normalizedField === 'external_id':
      label = 'External Id';
      break;

    case normalizedField === 'create_date' && entity !== 'workspaces':
      label = 'Creation Date';
      break;

    case normalizedField === 'creation_time':
      label = 'Creation Time';
      break;

    case normalizedField === 'last_modified':
      label = 'Last Modified';
      break;

    case normalizedField === 'open_services':
      label = 'Open Services';
      break;

    case normalizedField === 'severity_counts':
      label = 'Important Vulnerabilities';
      break;

    case normalizedField === 'important':
    case normalizedField === 'importance':
      label = 'Importance';
      break;

    case normalizedField === 'command':
      label = 'Command';
      break;

    case normalizedField === 'parameters':
      label = 'Parameters';
      break;

    case normalizedField === 'service__name':
      label = 'Service';
      break;

    case normalizedField === 'services_port':
      label = 'Services Port';
      break;

    case normalizedField === 'services_status':
      label = 'Services Status';
      break;

    case normalizedField === 'update_date' && entity !== 'workspaces':
      label = 'Updated';
      break;

    case normalizedField === 'risk':
      label = 'Total Risk Score';
      break;

    case normalizedField === 'create_date' && entity === 'workspaces':
      label = 'Creation Date';
      break;

    case normalizedField === 'update_date' && entity === 'workspaces':
      label = 'Last Modified';
      break;

    case normalizedField === 'range_dates':
      label = 'Start-end date';
      break;

    case normalizedField === 'name' && entity === 'workspaces':
      label = 'Workspace';
      break;

    case normalizedField === 'workspace_name':
      label = 'Workspace';
      break;

    case normalizedField === 'last_detected':
      label = 'Last Detected';
      break;

    case normalizedField === 'services':
      label = 'Services';
      break;

    case normalizedField === 'mac':
      label = 'Mac Address';
      break;

    case normalizedField === 'vulns':
      label = 'Vulnerabilities';
      break;

    case normalizedField === 'active' && entity === 'workspaces':
      label = 'Status';
      break;

    default:
      label =
        normalizedField.charAt(0).toUpperCase() +
        normalizedField.slice(1);
  }

  return isCustom ? `${label} (Custom Field)` : label;
}
